<template>
  <form-builder-editor-field
    :item="item"
    :show-hide-in-form="true"
    :show-hide-in-reports="true"
    :show-hide-in-preview="true"
    v-on="$listeners"
  >
    <label>Values</label>
    <vue-form-editor :schema="item.values"
                     :shared-fields="sharedFields"
                     :id="id"
                     :key="'accordion-editor'"
                     @add="clear"
                     @field-removed="$emit('field-removed', $event)"
    />
  </form-builder-editor-field>
</template>


<script>
import FormBuilderEditorField from "./FormBuilderEditorField";

export default {
  components: {
    FormBuilderEditorField,
    // XXX: this component needs to be lazy loaded, because otherwise 'vue template or render function not defined' is thrown
    // TODO: check if this is still happening after upgrade to Vue 3
    VueFormEditor: () => import('../VueFormEditor')
  },

  props: {
    id: {
      type: Number,
      default: null
    },
    sharedFields: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true
    }
  },

  setup(props) {
    const clear = () => {
      props.item.values = props.item.values.filter((v) => v.type !== 'accordion')
    }

    return {
      clear,
    }
  }
}
</script>

<style scoped lang="scss">
.dropArea {
  position: relative;
  background: #f5f5f5;
  min-height: 200px;
}

.dropArea.empty {
  opacity: 0.5;
  border: 1px dashed black;
  box-shadow: none;
}

.dropArea.empty:after {
  content: attr(data-content);
  position: absolute;
  text-align: center;
  top: 50%;
  left: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// FormBuilderEditorAccordion.vue?60419726